import React from 'react';
import styled from 'styled-components';
import { Modal } from 'semantic-ui-react';

const ConfirmPopup = ({
  title = '',
  text = '',
  isShow = false,
  onClose,
  onApply,
  additionalText = '',
}) => {
  return (
    <Modal open={isShow} onClose={onClose} closeIcon size="tiny">
      <WrapModal>
        <WrapHeadModal>
          <TitleModal>{title}</TitleModal>
        </WrapHeadModal>
        <WrapBodyModal>
          <ConfirmTextBody>
            {text}
            {additionalText && <AdditionalTextBody>{additionalText}</AdditionalTextBody>}
          </ConfirmTextBody>
          <WrapConfirmButtons>
            <ApplyButton onClick={onApply}>Подтвердить</ApplyButton>
            <CancelButton onClick={onClose}>Отменить</CancelButton>
          </WrapConfirmButtons>
        </WrapBodyModal>
      </WrapModal>
    </Modal>
  );
};

export default ConfirmPopup;

const WrapModal = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
  background-color: white;
`;

const WrapHeadModal = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
`;

const TitleModal = styled.div`
  font-size: 28px;
  font-weight: bold;
  margin: 7px 7px;
`;

const WrapBodyModal = styled.div`
  margin: 7px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ConfirmTextBody = styled.div`
  font-size: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const AdditionalTextBody = styled.div`
  padding-top: 5px;
  font-size: 12px;
  text-align: center;
`;

const WrapConfirmButtons = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Button = styled.button`
  margin: 25px auto;
  font-size: 20px;
  width: 200px;
  height: 50px;
  border: none;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
`;

const ApplyButton = Button.extend`
  background: rgb(93, 168, 52);
  &:hover {
    background: rgb(27, 129, 0);
  }
`;

const CancelButton = Button.extend`
  background: #3a3a3a;
  &:hover {
    background: #4f93c3;
    color: #000542;
    border: 1px solid #000542;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Common/ConfirmPopup.jsx